import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const dcoreTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.dcore,
  logoUrl: "https://cdn.nemuru.com/assets/logos/dcore-logo.svg",
  palette: {
    primary: {
      main: "#000000",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#B68F45",
      contrastText: "#000000",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "#fefbf3",
    },
    text: {
      title: "#000000",
      primary: "#333333",
      secondary: "#999999",
    },
    info: {
      main: "#008CFF",
      contrastText: "#ffffff",
      light: "#eef5fd",
    },
    success: {
      main: "#4dd970",
      contrastText: "#ffffff",
      light: "#f1faf1",
    },
    error: {
      main: "#ff4752",
      contrastText: "#ffffff",
      light: "#ffa9ae",
    },
    // additional colors
    dark: {
      main: "#af7c1b",
      accent: "#000000",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.FILLED,
  background: "#fff",
  customBorderRadius: {
    button: 4,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
};
